import { put, takeEvery,takeLatest } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  LOGIN_INIT_ACTION,
  FETCH_LOGIN_FAIL_ACTION,
  FETCH_LOGIN_SUCCESS_ACTION,
  LOGOUT_ACTION
} from "./actions";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* login(cred) {
  // console.log("ip==", appConfig.ip)
  try {
    const loginData = {
      UserID: cred.cred.UserID,
      password: cred.cred.password
    };

    const res = yield fetch(`${appConfig.ip}/auth`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization:
          "Basic " + btoa(loginData.UserID + ":" + loginData.password)
      }
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      // console.log("ressssssssssssssssss Login", resJSON);
      yield put({
        type: FETCH_LOGIN_SUCCESS_ACTION,
        payload: resJSON
      });
      localStorage.setItem("UserRole", resJSON.user.role);
      console.log(resJSON.user.role);
      /* if (resJSON.user.role == "licensee") {
        localStorage.setItem("token", resJSON.token);
        yield put(push("/dashboard"));
        yield toast.success("Login successfully", {
          autoClose: 3000
        });
      } else  */if (resJSON.user.role === "admin") {
        localStorage.setItem("token", resJSON.token);
        yield put(push("/dashboard"));
        yield toast.success("Login successfully", {
          autoClose: 3000
        });
      }else{
        yield toast.error("Only admin access allowed", {
          autoClose: 3000
        });
      }
    }
  } catch (err) {
    if (err.status === 401) {
      yield toast.error("Invalid credential", {
        autoClose: 3000,
        position: "top-center"
      });
    }

    yield put({
      type: FETCH_LOGIN_FAIL_ACTION,
      payload: err
    });
  }
}

function* logOut() {
  localStorage.removeItem("token");
}
export function* LoginActionWatcher() {
  yield takeLatest(LOGIN_INIT_ACTION, login);
  yield takeEvery(LOGOUT_ACTION, logOut);
}
